import { render } from "./FeaturedVideo.vue?vue&type=template&id=b0d8026e"
import script from "./FeaturedVideo.vue?vue&type=script&lang=js"
export * from "./FeaturedVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/components/FeaturedVideo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0d8026e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0d8026e', __exports__)) {
    api.reload('b0d8026e', __exports__)
  }
  
  module.hot.accept("./FeaturedVideo.vue?vue&type=template&id=b0d8026e", () => {
    api.rerender('b0d8026e', render)
  })

}


export default __exports__